import { type Meta } from '../types/docs';

export const AUTOMATIONS_ANALYTICS_CATEGORY = 'automations';

type MetaParam = NonNullable<Meta['params']>[number];

export const AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM = {
  description: 'The product surface this event belongs to',
  name: 'category',
  required: true,
  type: 'enum',
  values: [AUTOMATIONS_ANALYTICS_CATEGORY],
} satisfies MetaParam;

export const AUTOMATIONS_ANALYTICS_PAGES = ['list', 'create', 'detail'] as const;

export type AutomationsAnalyticsPage = (typeof AUTOMATIONS_ANALYTICS_PAGES)[number];

export const AUTOMATIONS_ANALYTICS_LIST_STATES = ['empty', 'populated'] as const;

export type AutomationsAnalyticsListState = (typeof AUTOMATIONS_ANALYTICS_LIST_STATES)[number];

export const AUTOMATIONS_ANALYTICS_ENTRY_SOURCES = ['skill_automate', 'in_app'] as const;

export type AutomationsAnalyticsEntrySource = (typeof AUTOMATIONS_ANALYTICS_ENTRY_SOURCES)[number];

export const AUTOMATIONS_ANALYTICS_PROMPT_MODES = ['skill_linked', 'custom'] as const;

export type AutomationsAnalyticsPromptMode = (typeof AUTOMATIONS_ANALYTICS_PROMPT_MODES)[number];

/** Matches `AutomationRepeat` in apps/core `automationSchedule.ts`. */
export const AUTOMATIONS_ANALYTICS_SCHEDULE_REPEATS = [
  'minute',
  '5min',
  '15min',
  '30min',
  'hour',
  'day',
  'weekdays',
  'week',
  'month',
] as const;

export type AutomationsAnalyticsScheduleRepeat = (typeof AUTOMATIONS_ANALYTICS_SCHEDULE_REPEATS)[number];

export const AUTOMATIONS_ANALYTICS_RUN_STATUSES = ['started', 'completed', 'failed', 'skipped'] as const;

export type AutomationsAnalyticsRunStatus = (typeof AUTOMATIONS_ANALYTICS_RUN_STATUSES)[number];

export const AUTOMATIONS_ANALYTICS_LIST_STATUSES = ['active', 'paused', 'failed'] as const;

export type AutomationsAnalyticsListStatus = (typeof AUTOMATIONS_ANALYTICS_LIST_STATUSES)[number];

export const AUTOMATION_CREATE_STARTED_LOCATIONS = ['list_header', 'list_empty', 'skill_page'] as const;

export type AutomationCreateStartedLocation = (typeof AUTOMATION_CREATE_STARTED_LOCATIONS)[number];

export const AUTOMATION_OPENED_LOCATIONS = ['list_table'] as const;

export type AutomationOpenedLocation = (typeof AUTOMATION_OPENED_LOCATIONS)[number];

export const AUTOMATION_RUNS_LIST_OPENED_LOCATIONS = ['agent_tasks_list', 'automation_detail'] as const;

export type AutomationRunsListOpenedLocation = (typeof AUTOMATION_RUNS_LIST_OPENED_LOCATIONS)[number];

export const AUTOMATION_RUNS_LOAD_MORE_LOCATIONS = ['agent_panel', 'detail_sidebar'] as const;

export type AutomationRunsLoadMoreLocation = (typeof AUTOMATION_RUNS_LOAD_MORE_LOCATIONS)[number];

export const AUTOMATION_RUN_SESSION_OPENED_LOCATIONS = ['agent_panel', 'detail_sidebar'] as const;

export type AutomationRunSessionOpenedLocation = (typeof AUTOMATION_RUN_SESSION_OPENED_LOCATIONS)[number];

export const withAutomationsCategory = <T extends Record<string, unknown>>(params: T) => ({
  category: AUTOMATIONS_ANALYTICS_CATEGORY,
  ...params,
});
